import { EvidenceForRegion } from "../../api/models/Dashboard";
import { ragToBgClassMap, ragToRgb } from "../../constants";
import Card from "../Card";
import RegionalMap from "./RegionalMap";
import EvidenceRagChip from "./EvidenceRagChip";
import GridTable from "./GridTable";
import HorizontalBar from "./HorizontalBar";

export type ByRegionEvidenceProps = {
    emissionsSourceEvidenceByRegion: EvidenceForRegion[];
};

const ByRegionEvidence = ({
    emissionsSourceEvidenceByRegion,
}: ByRegionEvidenceProps) => {
    const data = emissionsSourceEvidenceByRegion.map((_) => ({
        id: _.regionId,
        name: _.regionName,
        redCount: _.missingCount,
        amberCount: _.expiringIn30DaysCount,
        greenCount: _.inDateCount,
        color:
            _.missingCount > 0
                ? ragToRgb.red
                : _.expiringIn30DaysCount > 0
                ? ragToRgb.amber
                : ragToRgb.green,
    }));

    const ragTotalMax = Math.max(
        ...data.map((_) => _.redCount + _.amberCount + _.greenCount)
    );

    return (
        <div className="flex lg:space-x-6 items-center">
            <Card className="hidden lg:block bg-white border-surface-light-5 border-2 shrink-0 w-[350px] p-2">
                <RegionalMap regionColors={data} />
            </Card>
            <GridTable
                gridTemplateColumns="1fr 1fr 150px"
                data={data}
                headings={[
                    { label: "Region" },
                    { label: "RAG count" },
                    { label: "Overall status" },
                ]}
                renderRow={(rowData) => (
                    <>
                        <div className="px-4 py-3 whitespace-nowrap overflow-hidden text-ellipsis">
                            {rowData.name}
                        </div>
                        {rowData.redCount +
                            rowData.amberCount +
                            rowData.greenCount >
                        0 ? (
                            <HorizontalBar
                                data={[
                                    {
                                        value: rowData.redCount,
                                        color: ragToBgClassMap["red"],
                                    },
                                    {
                                        value: rowData.amberCount,
                                        color: ragToBgClassMap["amber"],
                                    },
                                    {
                                        value: rowData.greenCount,
                                        color: ragToBgClassMap["green"],
                                    },
                                ]}
                                total={ragTotalMax}
                            />
                        ) : (
                            <p className="text-gray-400">No data</p>
                        )}
                        <div className="px-4 py-2">
                            <EvidenceRagChip
                                red={rowData.redCount}
                                amber={rowData.amberCount}
                            />
                        </div>
                    </>
                )}
            />
        </div>
    );
};

export default ByRegionEvidence;
